import type { Contact } from "./api/types";

export const DEFAULT_EMERGENCY_CONTACT: Contact = {
  id: "fallback-emergency-contact",
  name: "紧急联系人",
  relation: "电话兜底",
  phone_display: "1**********",
  tel_uri: "tel:+8613800000000",
  sms_uri: "sms:+8613800000000",
  is_default: true,
  is_emergency: true,
};

export function pickEmergencyContact(contacts: Contact[]): Contact {
  return (
    contacts.find((contact) => contact.is_emergency) ??
    contacts.find((contact) => contact.is_default) ??
    contacts[0] ??
    DEFAULT_EMERGENCY_CONTACT
  );
}
